import React, { createContext } from 'react'
import { ExperiencePreviewUtils, useExperiencePreviewUtils } from '../utils/useExperiencePreviewUtils'
import { ExperiencePreviewVariant } from 'pages/consentAndRights/experiences-v2/view/components/experiencePreview/constants'

export const ExperiencePreviewContext = createContext({} as ExperiencePreviewUtils)

type Props = {
  children?: React.ReactNode | undefined
  variant?: ExperiencePreviewVariant // Accept optional variant prop
}

export const ExperiencePreviewContextProvider: React.FC<Props> = ({ children, variant }) => {
  // Use utils hook, forward variant
  const hookValues = useExperiencePreviewUtils({ variant })

  return <ExperiencePreviewContext.Provider value={{ ...hookValues }}>{children}</ExperiencePreviewContext.Provider>
}

export const withExperiencePreviewContext = (Component: React.FC<any>) => {
  return (props: any) => {
    return (
      <ExperiencePreviewContextProvider variant={props.variant}>
        <Component {...props} />
      </ExperiencePreviewContextProvider>
    )
  }
}
